function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2.-Rollover-Call-Dashboard",
  transform: "translate(-64.000000, -312.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(64.000000, 244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "assignment_black_24dp",
  transform: "translate(0.000000, 68.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.66666667,10 L9.33333333,10 L9.33333333,11.3333333 L4.66666667,11.3333333 L4.66666667,10 Z M4.66666667,7.33333333 L11.3333333,7.33333333 L11.3333333,8.66666667 L4.66666667,8.66666667 L4.66666667,7.33333333 Z M4.66666667,4.66666667 L11.3333333,4.66666667 L11.3333333,6 L4.66666667,6 L4.66666667,4.66666667 Z M12.6666667,2 L9.88,2 C9.6,1.22666667 8.86666667,0.666666667 8,0.666666667 C7.13333333,0.666666667 6.4,1.22666667 6.12,2 L3.33333333,2 C3.24,2 3.15333333,2.00666667 3.06666667,2.02666667 C2.80666667,2.08 2.57333333,2.21333333 2.39333333,2.39333333 C2.27333333,2.51333333 2.17333333,2.66 2.10666667,2.82 C2.04,2.97333333 2,3.14666667 2,3.33333333 L2,12.6666667 C2,12.8466667 2.04,13.0266667 2.10666667,13.1866667 C2.17333333,13.3466667 2.27333333,13.4866667 2.39333333,13.6133333 C2.57333333,13.7933333 2.80666667,13.9266667 3.06666667,13.98 C3.15333333,13.9933333 3.24,14 3.33333333,14 L12.6666667,14 C13.4,14 14,13.4 14,12.6666667 L14,3.33333333 C14,2.6 13.4,2 12.6666667,2 Z M8,1.83333333 C8.27333333,1.83333333 8.5,2.06 8.5,2.33333333 C8.5,2.60666667 8.27333333,2.83333333 8,2.83333333 C7.72666667,2.83333333 7.5,2.60666667 7.5,2.33333333 C7.5,2.06 7.72666667,1.83333333 8,1.83333333 Z M12.6666667,12.6666667 L3.33333333,12.6666667 L3.33333333,3.33333333 L12.6666667,3.33333333 L12.6666667,12.6666667 Z",
  id: "Shape",
  fill: "#0AA6A8",
  fillRule: "nonzero"
})))));

function SvgAssignmentBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9FA28A3B-4889-4590-BAAE-AC495586F9FF@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentBlack24Dp);
export default __webpack_public_path__ + "static/media/assignment_black_24dp.f0a9cd37.svg";
export { ForwardRef as ReactComponent };